// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"467":"5612dc1b","552":"47a23d4c","657":"6e09a938","914":"be79b4bc"}[chunkId] + ".css";
};